import { render } from "./PayloadDiffField.vue?vue&type=template&id=362dfd6c&scoped=true"
import script from "./PayloadDiffField.vue?vue&type=script&lang=js"
export * from "./PayloadDiffField.vue?vue&type=script&lang=js"

import "./PayloadDiffField.vue?vue&type=style&index=0&id=362dfd6c&scoped=true&lang=css"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-362dfd6c"],['__file',"PayloadDiffField.vue"]])

export default __exports__